export default __webpack_public_path__ + "static/media/illustration-recruit-1-m@2x.3179ae05.webp";